// extracted by mini-css-extract-plugin
module.exports = {"panelResizeDivider":"panelResizeDivider_panelResizeDivider__3usYu","panelResizeDivider__iconWrapper":"panelResizeDivider_panelResizeDivider__iconWrapper__3pNG4"};